// Storage can be unavailable at the property getter as well as at the operation itself.
const guarded = storageName => ({
  getItem(key) {
    try {
      return window[storageName].getItem(key);
    } catch (e) {
      return null;
    }
  },
  setItem(key, value) {
    try {
      return window[storageName].setItem(key, value);
    } catch (e) {
      return null;
    }
  },
  removeItem(key) {
    try {
      return window[storageName].removeItem(key);
    } catch (e) {
      return null;
    }
  },
});

const safeStorage = guarded('localStorage');

// The same guard for the tab's sessionStorage (credential links, once-per-session markers).
export const safeSessionStorage = guarded('sessionStorage');

export default safeStorage;
